module.exports = __webpack_public_path__ + "media/แลกปีกกับหาง.5122d748.mp3";